/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const Refresh: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path d='M8 0C10.1571 0 12.1748 0.86012 13.6563 2.34235L14.998 1V5H11L12.2425 3.75691C11.1307 2.64424 9.619 2 8 2C4.68629 2 2 4.68629 2 8C2 8.55229 1.55228 9 1 9C0.447715 9 0 8.55229 0 8C0 3.58172 3.58172 0 8 0Z' />
			<path d='M3.75641 12.2422L4.99804 11H1V15L2.34255 13.6568C3.8207 15.1362 5.83881 16 8 16C12.4183 16 16 12.4183 16 8C16 7.44772 15.5523 7 15 7C14.4477 7 14 7.44772 14 8C14 11.3137 11.3137 14 8 14C6.37806 14 4.8655 13.3527 3.75641 12.2422Z' />
		</Svg>
	);
};

export { Refresh };
